import { render, staticRenderFns } from "./TalkSearchRecord.vue?vue&type=template&id=24dedaaf&scoped=true&"
import script from "./TalkSearchRecord.vue?vue&type=script&lang=js&"
export * from "./TalkSearchRecord.vue?vue&type=script&lang=js&"
import style0 from "./TalkSearchRecord.vue?vue&type=style&index=0&id=24dedaaf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dedaaf",
  null
  
)

export default component.exports